export default __webpack_public_path__ + "static/media/airAsia.22c5033b.png";